import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class LiveMealFilterEntity {
  regions?: RegionMiniEntity[]
  statuses?: Array<MealStatus>
  fetchAll?: boolean
  fromDate?: string
  toDate?: string
}
